globalThis.Status = class Status {
  constructor() {
    this.abort = new AbortController();
    this.div = document.createElement("div");
    this.div.id = "status";
    this.div.addEventListener("mousedown", globalThis.cancelbubble, this.abort);
    addEventListener("store", this.update.bind(this), this.abort);
    addEventListener("worldsize", this.update.bind(this), this.abort);
    addEventListener("route", this.update.bind(this), this.abort);
    document.body.append(this.div);
    this.update();
  }

  remove() {
    this.abort.abort();
    this.div.remove();
  }

  update() {
    const activeid = globalThis.GAME.id;
    const name = activeid || "<New>";
    let size = "";
    if (globalThis.WORLD) {
      const { x, y } = globalThis.WORLD.size;
      size = `(${x}x${y})`;
    }
    if (activeid) document.title = `Platfo | ${name}`;
    else document.title = "Platfo";
    this.div.innerText = [name, size].join(" ");
  }
};
